import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useCreateCmsChallenge = () => {
  const queryClient = useQueryClient();
   const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ data, challengeId }) => {
      // Check if it's an update (has challengeId) or create (no challengeId)
      const isUpdate = !!challengeId;
      
      const result = await restClient({
        url: isUpdate ? `${prefix}/cms/challenge/${challengeId}` : `${prefix}/cms/challenge`,
        method: isUpdate ? 'PUT' : 'POST',
        data: data // Send only the data, not the challengeId
      });
      return result;
    },
    onSuccess: () => {
      // Invalidate and refetch user groups list after successful creation/update
      queryClient.invalidateQueries(['resultsChallenges']);
    }
  });
};
